// Persist and retrieve the user's preferred iTunes search storefront country.
// Falls back to the locale-derived default when no explicit preference is stored.
const LS_KEY = 'gar_search_region';

/**
 * Return the stored search region, or null if none has been set.
 * @returns {string|null}
 */
export function getStoredSearchRegion() {
  try {
    return localStorage.getItem(LS_KEY) || null;
  } catch {
    return null;
  }
}

/**
 * Persist the user's chosen search region country code.
 * @param {string} countryCode  - ISO 3166-1 alpha-2 (e.g. 'us', 'jp')
 */
export function setSearchRegion(countryCode) {
  try {
    localStorage.setItem(LS_KEY, countryCode);
  } catch {
    // storage quota / private-mode: silently ignore
  }
}

/**
 * Remove any stored preference, reverting to locale-based default.
 */
export function clearSearchRegion() {
  try {
    localStorage.removeItem(LS_KEY);
  } catch {
    // ignore
  }
}
